import type { Partner, PartnerType } from '@/types/api'
import { createCrudService } from '../crud'

export type PartnerInput = Pick<
  Partner,
  'currency_id' | 'code' | 'name' | 'batch_letter' | 'tin' | 'phone' | 'email' | 'address' | 'status'
> & { partner_types: PartnerType[] }

export const partnersService = createCrudService<Partner, PartnerInput, Partial<PartnerInput>>('parties/partners')
